import React from 'react';
import { SummaryType } from '@ls/grouping-service';
import { titleCase } from '@ls/js-utils';
import { useDispatch, useSelector } from 'react-redux';
import CalcType from 'state/Constants/CalcType';
import ScaleType from 'state/Constants/ScaleType';
import SelectionState from 'state/selections/SelectionState';
import { DELETE_DEFINITION } from './actions';
import { selectDefinitions, selectFetchingData } from './selectors';

export const useColumnDefs = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((columnDefs, definition) => {
      const { factorType, calcType, period, scaleType, key } = definition;
      const columnDef = {
        field: key,
        colId: key,
        X_onDelete: () => dispatch({ type: DELETE_DEFINITION, payload: definition }),
      };
      switch (calcType) {
        case CalcType.Account:
          columnDef.headerName = `Acct ${scaleType === ScaleType.Contribution ? `C-` : ``}${titleCase(factorType)}, ${titleCase(period)}`;
          columnDef.loading = fetchingAbsData;
          break;
        case CalcType.Relative:
          columnDef.headerName = `Rel ${scaleType === ScaleType.Contribution ? `C-` : ``}${titleCase(factorType)}, ${titleCase(period)}`;
          columnDef.loading = fetchingRelData;
          break;
        case CalcType.Benchmark:
          columnDef.headerName = `Bench ${scaleType === ScaleType.Contribution ? `C-` : ``}${titleCase(factorType)}, ${titleCase(period)}`;
          columnDef.loading = fetchingAbsData;
          break;
        default:
          throw Error('Unknown calc type: ' + calcType);
      }
      columnDefs.push(columnDef);
      return columnDefs;
    }, []);
  }, [dispatch, definitions, fetchingAbsData, fetchingRelData]);
};